import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
type CheckItemProps = {
  children: React.ReactNode;
  variant?: 'check' | 'cross';
  className?: string;
};
export function CheckItem({
  children,
  variant = 'check',
  className = ''
}: CheckItemProps) {
  const isCheck = variant === 'check';
  return <li className={`flex items-start gap-3 ${className}`} data-id="element-16" data-mp="2c1oc6b2yhjci">
      <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${isCheck ? 'bg-accent text-zinc-950' : 'border border-zinc-700 text-zinc-500'}`} data-id="element-17" data-mp="2c04tyexqoy83">
        {isCheck ? <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-18" data-mp="222763sjsl3g0" /> : <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-19" data-mp="1o5tyrc8z2if9" />}
      </span>
      <span data-id="element-20" data-mp="1t4n7krdbdl93">{children}</span>
    </li>;
}